<template>
	<div>
		<loading v-if="!loaded" />
		<el-tabs v-model="tabName" v-if="loaded">
			<el-tab-pane label="ប្រវត្តិប្រតិបត្តិកាទាំងអស់" name="first"></el-tab-pane>
		</el-tabs>
		<div v-if="tabName == 'first' && loaded">
			<div class="md-layout">
				<div class="md-layout-item md-small-size-100 md-size-40">
					<md-field>
						<label>ស្វែងរកប្រត្តិបត្តិការតាមរយៈលេខកូដ ឬ ពាក្យសំគាល់</label>
						<md-input v-model="search.text" type="text" @keyup.enter="searchHandler()"></md-input>
					</md-field>
				</div>
				<!-- <div class="md-layout-item md-small-size-100 md-size-30">
					<md-field>
						<label>Transaction Tag</label>
						<md-select placeholder="Transaction Tag (All)" v-model="search.tag">
							<md-option value="">All</md-option>
							<md-option v-for="tag in tagList" :value="tag.id">{{tag.name}}</md-option>
						</md-select>
					</md-field>
				</div> -->
				<div class="md-layout-item md-size-30">
					<md-button class="md-raised md-primary" @click="searchHandler()" style="width: 100%">ស្វែងរក</md-button>
				</div>
			</div>
			<md-table v-if="transactionList.length > 0" style="width: 100%">
				<md-table-row>
					<md-table-head></md-table-head>
					<md-table-head>លេខកូដ</md-table-head>
					<!-- <md-table-head>ប្រភេទប្រតិបត្តិការ</md-table-head> -->
					<md-table-head>ចំនួន</md-table-head>
					<md-table-head>អតិថិជន</md-table-head>
					<md-table-head>រំលោះ និងគម្រោង</md-table-head>
					<md-table-head>អ្នកបង្កើត និងកាលបរិច្ឆេទ</md-table-head>
					<md-table-head>សកម្មភាព</md-table-head>
				</md-table-row>

				<md-table-row v-for="(transaction, index) in transactionList">
					<md-table-cell><b>{{ index + 1 }}</b></md-table-cell>
					<md-table-cell><b>{{ transaction.hash }}</b><br><span class="active">{{transaction.name}}</span></md-table-cell>
					<md-table-cell><b>{{ config.moneylify(transaction.amount) }}</b></md-table-cell>
					<md-table-cell><b>{{ transaction.client_name }}</b><br>ID: {{ transaction.client_hash }}</md-table-cell>
					<md-table-cell><b>{{ transaction.note }}</b><br>{{transaction.project_name}} ({{transaction.loan_lot}})</md-table-cell>
					<md-table-cell><b>{{transaction.tx_by}}</b><br>{{ config.datelify(transaction.created_date) }}</md-table-cell>
					<md-table-cell>
						<router-link :to="'/loans/detail/' + transaction.loan_hash">
							<md-button class="md-just-icon md-simple md-primary">
								<md-icon>request_quote</md-icon>
								<md-tooltip md-direction="top">មើលរំលោះបន្ថែម</md-tooltip>
							</md-button>
						</router-link>
						<router-link :to="'/clients/detail/' + transaction.client_hash">
							<md-button class="md-just-icon md-simple md-primary">
								<md-icon>person</md-icon>
								<md-tooltip md-direction="top">មើលអតិថិជនបន្ថែម</md-tooltip>
							</md-button>
						</router-link>
					</md-table-cell>
				</md-table-row>
			</md-table>

			<h4 class="text-center" v-if="transactionList.length == 0">មិនមានប្រតិបត្តិការ</h4>
			<div class="places-buttons text-center" v-if="loadMore" >
				<md-button class="md-primary" @click="searchHandler(true)">បង្ហាញបន្ថែម</md-button>
			</div>
		</div>

		<!-- <md-dialog-confirm :md-active.sync="deleteDialogActive" md-title="តើអ្នកពិតជាចង់លុបក្រុមហ៊ុននេះពិតមែនទេ ?"
			md-content="ព័ត៌មានក្រុមហ៊ុននឹងត្រូវបានលុបចេញពីបញ្ជីជារាងរហូត។" md-confirm-text="លុប" md-cancel-text="បោះបង់"
			@md-cancel="onCancel" @md-confirm="onDelete" /> -->
	</div>

</template>

<script>
	import { Datetime } from 'vue-datetime';
	export default {
		components: { Datetime },
		created() {
			this.searchHandler();
			this.getSettings();
		},
		data() {
			return {
				tabName: "first",
				loaded: false,
				transaction: {
					valid: false,
					type: "",
					tag: "",
					amount: "",
					remark: ""
				},
				search: {
					text: "",
					tag: "",
				},
				loadMoren: false,
				tagList: [],
				transactionList: []
			}
		},
		computed: {
			total_deposit() {
				let total = 0;
				for(let i = 0; i< this.transactionList.length; i++) {
					if(this.transactionList[i].type == 'd') {
						total = total + this.transactionList[i].amount;
					}
				}
				return total;
			},
			total_withdraw() {
				let total = 0;
				for(let i = 0; i< this.transactionList.length; i++) {
					if(this.transactionList[i].type == 'w') {
						total = total + this.transactionList[i].amount;
					}
				}
				return total;
			},
			total_transaction() {
				return this.total_deposit - this.total_withdraw;
			}
		},
		methods: {
			getSettings() {
				this.$http.get(this.config.api + "/admin/setting/data/get_all").then(data => {
					this.tagList = data.body.data.tag
				})
			},
			// getTransaction() {
			// 	this.$http.get(this.config.api + "/admin/transaction/get/list/0").then(data => {
			// 		this.transactionList = data.body.data
			// 		this.loaded = true;
			// 	})
			// },
			checkValidation() {
				if (String(this.transaction.type).length > 0 && String(this.transaction.amount).length > 0 && String(this.transaction.tag).length > 0) {
					this.transaction.valid = true
				} else {
					this.transaction.valid = false
				}
			},
			// showDeleteAction(id) {
			// 	this.deleteSelected = id
			// 	this.deleteDialogActive = true
			// },
			searchHandler(more = false) {
				this.$http.post(this.config.api + "/admin/transaction/search", {
					text: this.search.text,
					tag: this.search.tag,
					offset: more ? this.transactionList.length : 0
				}).then(data => {
					this.loaded = true;
					this.search.text = "";
					this.transactionList = more ? this.transactionList.concat(data.body.data) : data.body.data;
					if (data.body.data.length == 50) this.loadMore = true
					else this.loadMore = false
				})
			},
			// onCancel() {
			// 	this.deleteSelected = ""
			// 	this.deleteDialogActive = false
			// }
		}
	}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/pages/Transactions/View.vue